(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-header"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('studio-shop-header'))customElements.define('studio-shop-header',class extends HTMLElement{
connectedCallback(){this.controller=new AbortController();const signal=this.controller.signal;
const mobile=this.mobile=matchMedia('(max-width:749px)');
const dialog=this.querySelector('.cs-mobile-menu');
const menuButton=this.querySelector('[data-mobile-menu]');
const searchButton=this.querySelector('[data-mobile-search]');
const input=this.querySelector('.cs-search input');
const closeSearch=(restore=false)=>{this.classList.remove('cs-mobile-search-open');searchButton.setAttribute('aria-expanded','false');if(restore)searchButton.focus()};
const appCloseSelector='.boost-sd__search-bar-wrapper--mobile [data-group="close-search-form"]';
document.addEventListener('click',event=>{if(mobile.matches&&event.target instanceof Element&&event.target.closest(appCloseSelector)){closeSearch();queueMicrotask(()=>{if(this.isConnected)searchButton.focus()})}},{capture:true,signal});
let appWasOpen=false;
const appSearchScope='.boost-sd__search-bar-wrapper,.boost-sd__search-bar-wrapper--mobile,.boost-sd__search-widget-init-wrapper,.boost-sd__instant-search-container';
const setControlIcon=(button,kind)=>{
 const label=kind==='back'?this.dataset.searchBackLabel:this.dataset.searchClearLabel;
 if(button.getAttribute('aria-label')!==label)button.setAttribute('aria-label',label);
 if(button.tagName==='BUTTON')button.removeAttribute('role');
 if(button.dataset.csSearchControl!==kind)button.dataset.csSearchControl=kind;
 if(button.children.length===1&&button.firstElementChild.classList.contains('cs-search-control-icon')&&button.childNodes.length===1)return;
 const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');
 icon.classList.add('cs-search-control-icon');icon.setAttribute('viewBox','0 0 24 24');icon.setAttribute('aria-hidden','true');icon.setAttribute('focusable','false');
 const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d',kind==='back'?'M19 12H5m7-7-7 7 7 7':'m6 6 12 12M6 18 18 6');icon.append(path);button.replaceChildren(icon);
};
const syncAppSearch=()=>{
 document.querySelectorAll(appSearchScope).forEach(root=>{
  root.querySelectorAll('[data-group="close-search-form"]').forEach(button=>{if(mobile.matches)setControlIcon(button,'back')});
  root.querySelectorAll('button').forEach(button=>{
   if(button.matches('[data-group="close-search-form"]'))return;
   const group=button.getAttribute('data-group')||'';
   if(button.dataset.csSearchControl==='clear'||button.classList.contains('boost-sd__button-text-x--clear')||/^clear-(search|input)/.test(group)||/^(clear|löschen)$/i.test(button.textContent.trim()))setControlIcon(button,'clear');
  });
 });
 if(!mobile.matches)return;
 const wrappers=[...document.querySelectorAll('.boost-sd__search-bar-wrapper--mobile')];
 const appOpen=wrappers.some(wrapper=>!wrapper.hidden&&!wrapper.classList.contains('boost-sd__g-hide')&&getComputedStyle(wrapper).display!=='none'&&getComputedStyle(wrapper).visibility!=='hidden');
 if(appWasOpen&&!appOpen&&this.classList.contains('cs-mobile-search-open'))closeSearch(true);
 appWasOpen=appOpen;
};
const queueAppSearch=()=>{if(!this.searchFrame)this.searchFrame=requestAnimationFrame(()=>{this.searchFrame=0;syncAppSearch()})};
const observedSearchRoots=new WeakSet();
this.searchRootObserver=new MutationObserver(queueAppSearch);
const discoverSearchRoots=root=>{
 const candidates=[...(root.matches?.(appSearchScope)?[root]:[]),...root.querySelectorAll(appSearchScope)];
 for(const candidate of candidates){
  if(observedSearchRoots.has(candidate)||candidate.parentElement?.closest(appSearchScope))continue;
  observedSearchRoots.add(candidate);
  this.searchRootObserver.observe(candidate,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','hidden']});
 }
 return candidates.length>0;
};
discoverSearchRoots(document);
this.searchObserver=new MutationObserver(records=>{
 let changed=false;
 for(const record of records){
  if(record.target instanceof Element&&record.target.closest(appSearchScope))continue;
  for(const node of record.addedNodes)if(node instanceof Element&&discoverSearchRoots(node))changed=true;
  for(const node of record.removedNodes)if(node instanceof Element&&(node.matches(appSearchScope)||node.querySelector(appSearchScope)))changed=true;
 }
 if(changed)queueAppSearch();
});
this.searchObserver.observe(document.body,{subtree:true,childList:true});
syncAppSearch();

menuButton.addEventListener('click',()=>{closeSearch();dialog.showModal();menuButton.setAttribute('aria-expanded','true')},{signal});
this.querySelector('[data-mobile-menu-close]').addEventListener('click',()=>dialog.close(),{signal});
dialog.addEventListener('close',()=>{menuButton.setAttribute('aria-expanded','false');if(mobile.matches)menuButton.focus()},{signal});
dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}},{signal});
searchButton.addEventListener('click',event=>{if(!mobile.matches)return;event.preventDefault();if(this.classList.contains('cs-mobile-search-open')){closeSearch(true);return}this.classList.add('cs-mobile-search-open');searchButton.setAttribute('aria-expanded','true');input.focus()},{signal});
this.querySelector('[data-mobile-search-close]').addEventListener('click',()=>closeSearch(true),{signal});
this.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.classList.contains('cs-mobile-search-open'))closeSearch(true)},{signal});
mobile.addEventListener('change',()=>{if(!mobile.matches){if(dialog.open)dialog.close();closeSearch()}},{signal});
document.addEventListener('click',event=>{if(!this.contains(event.target))this.querySelectorAll('details[open]').forEach(d=>d.open=false)},{signal});this.addEventListener('keydown',event=>{if(event.key==='Escape'){const switcher=event.target.closest('.cs-shop-switch[open]');if(switcher){event.preventDefault();event.stopPropagation();switcher.open=false;switcher.querySelector('summary').focus();return}const menu=this.querySelector('.cs-mega');if(menu.open){menu.open=false;menu.querySelector('summary').focus()}}},{signal});this.querySelectorAll('[data-studio-cart]').forEach(link=>link.addEventListener('click',event=>{const drawer=document.getElementById('cart-drawer');if(typeof drawer?.open==='function'){event.preventDefault();drawer.open()}},{signal}));document.addEventListener('shopify:cart:lines-update',event=>{event.promise?.then(({cart,detail})=>{const count=cart?.totalQuantity??detail?.itemCount;if(typeof count==='number'&&this.isConnected)this.querySelectorAll('[data-studio-count]').forEach(badge=>badge.textContent=count)}).catch(()=>{})},{signal})}
disconnectedCallback(){this.controller?.abort();this.searchObserver?.disconnect();this.searchRootObserver?.disconnect();cancelAnimationFrame(this.searchFrame)}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-system"]) return;
  try {
    
{
  const dictionary = JSON.parse(document.getElementById('StudioTranslationLabels')?.textContent || '{}');
  const labels = new Map(Object.entries(dictionary));
  const scope = '.boost-sd__search-widget-init-wrapper, .boost-sd__instant-search-container, .boost-sd-container-search-page';
  const align = () => {
    const header = document.querySelector('.cs-header-main');
    const search = document.querySelector('.cs-search');
    if (!header || !search) return;
    const bounds = header.getBoundingClientRect();
    const searchBounds = search.getBoundingClientRect();
    const values = {'--studio-search-width': `${bounds.width}px`, '--studio-search-left': `${bounds.left + window.scrollX}px`, '--studio-search-top': `${Math.max(8,searchBounds.bottom + 8)}px`};
    for (const [name,value] of Object.entries(values)) if (document.documentElement.style.getPropertyValue(name) !== value) document.documentElement.style.setProperty(name,value);
  };
  const translate = () => {
    document.querySelectorAll(scope).forEach(root => {
      root.querySelectorAll('.boost-sd__filter-option-title').forEach(button => {
        const heading = button.querySelector('.boost-sd__filter-option-heading');
        if (heading) {
          const label = labels.get(heading.textContent.trim().toLowerCase()) || heading.textContent.trim();
          const accessible = `${dictionary.filter_by}: ${label}`;
          if (button.getAttribute('aria-label') !== accessible) button.setAttribute('aria-label', accessible);
        }
      });
      root.querySelectorAll('.boost-sd__header-item,.boost-sd__filter-option-heading,.boost-sd__search-result-toolbar-panel').forEach(heading => {
        for (const node of heading.childNodes) {
          if (node.nodeType !== Node.TEXT_NODE) continue;
          const value = labels.get(node.textContent.trim().toLowerCase());
          if (value && node.textContent !== value) node.textContent = value;
          else if (/^Products\s*\(/i.test(node.textContent.trim())) node.textContent = node.textContent.replace(/Products/i, dictionary.products);
        }
      });
    });
  };
  let pending = false;
  const refresh = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; translate(); });
  };
  new MutationObserver(records => {
    if (records.some(record => record.target instanceof Element && (record.target.closest(scope) || [...record.addedNodes].some(node => node instanceof Element && (node.matches(scope) || node.querySelector(scope)))))) refresh();
  }).observe(document.body, {childList:true,subtree:true});
  let alignPending = false;
  const queueAlign = () => {if (!alignPending) {alignPending = true; requestAnimationFrame(() => {alignPending = false; align();});}};
  window.addEventListener('resize', queueAlign, {passive:true});
  document.addEventListener('focusin', event => {if (event.target instanceof Element && event.target.closest('.cs-search')) queueAlign();});
  window.visualViewport?.addEventListener('resize', queueAlign, {passive:true});
  queueAlign();
  refresh();
}

{
 const dictionary=JSON.parse(document.getElementById('StudioTranslationLabels')?.textContent || '{}');
 const selector='.oh-card-categories__media img[loading="lazy"]';
 const navSelector='button[aria-label="Slide next"],button[aria-label="Slide back"]';
 const enhance=root=>{
  for(const button of [...(root.matches?.(navSelector)?[root]:[]),...root.querySelectorAll(navSelector)]){
   if(button.closest('.shopify-section')?.querySelector('.oh-card-categories'))button.setAttribute('aria-label',button.getAttribute('aria-label')==='Slide next'?dictionary.next_categories:dictionary.previous_categories);
  }
  const images=[...(root.matches?.(selector)?[root]:[]),...root.querySelectorAll(selector)];
  for(const img of images)if(img.sizes.includes('normalpx'))img.sizes='auto, (min-width: 1000px) 220px, calc((100vw - 48px) / 2)';
 };
 enhance(document);
 const roots=new Set();
 let frame=0;
 new MutationObserver(records=>{
  for(const record of records)for(const node of record.addedNodes){
   if(!(node instanceof Element))continue;
   roots.add(node);
  }
  if(!roots.size||frame)return;
  frame=requestAnimationFrame(()=>{
   frame=0;
   for(const root of roots){
    if(!root.isConnected)continue;
    let ancestor=root.parentElement;
    while(ancestor&&!roots.has(ancestor))ancestor=ancestor.parentElement;
    if(!ancestor)enhance(root);
   }
   roots.clear();
  });
 }).observe(document.body,{childList:true,subtree:true});
}

{
 const enhanceUpsell = root => {
  const within = selector => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  for (const img of within('.cs-product-three .product-details lb-upsell-widget img.lb-card-img')) {
   const source = img.getAttribute('src') || '';
   if (!/_400x400\.(?:webp|jpe?g|png)(?:\?|$)/i.test(source)) continue;
   const url = new URL(source, document.baseURI);
   if (url.hostname !== 'cdn.shopify.com' && url.hostname !== location.hostname) continue;
   if (!img.hasAttribute('width')) img.setAttribute('width', '400');
   if (!img.hasAttribute('height')) img.setAttribute('height', '400');
   img.decoding = 'async';
   const flat = !!img.closest('.lb-flat-card');
   const sizes = flat ? '60px' : 'auto, (min-width: 1000px) 280px, (min-width: 750px) 240px, 180px';
   if (!img.closest('.product-details')) img.loading = 'lazy';
   if (img.sizes !== sizes) img.sizes = sizes;
   const widths = flat ? [120,240,400] : [160,240,400];
   const srcset = widths.map(width => source.replace('_400x400.', `_${width}x${width}.`) + ` ${width}w`).join(', ');
   if (img.srcset !== srcset) img.srcset = srcset;
  }
  for (const list of within('lb-upsell-widget .lb-bundle-products, lb-upsell-widget .lb-bundle-offers, lb-upsell-widget .lb-bundle-tgrid-trigger')) {
   const role = list.querySelector(':scope > [role="listitem"]') ? 'list' : 'group';
   if (list.getAttribute('role') !== role) list.setAttribute('role', role);
  }
 };
 const pendingWidgets = new Set();
 const imageObservers = new Map();
 const discoveryRoots = new Set();
 let frame = 0;
 const register = widget => {
  if (imageObservers.has(widget)) return;
  const observer = new MutationObserver(() => {
   pendingWidgets.add(widget);
   queue();
  });
  observer.observe(widget, {attributes:true,subtree:true,attributeFilter:['src']});
  imageObservers.set(widget, observer);
  pendingWidgets.add(widget);
 };
 const discover = root => {
  if (root.matches?.('lb-upsell-widget')) register(root);
  for (const widget of root.querySelectorAll('lb-upsell-widget')) register(widget);
 };
 const queue = () => {
  if (frame) return;
  frame = requestAnimationFrame(() => {
   frame = 0;
   for (const root of discoveryRoots) {
    if (!root.isConnected) continue;
    let ancestor = root.parentElement;
    while (ancestor && !discoveryRoots.has(ancestor)) ancestor = ancestor.parentElement;
    if (!ancestor) discover(root);
   }
   discoveryRoots.clear();
   for (const [widget, observer] of imageObservers) {
    if (widget.isConnected) continue;
    observer.disconnect();
    imageObservers.delete(widget);
    pendingWidgets.delete(widget);
   }
   for (const widget of pendingWidgets) if (widget.isConnected) enhanceUpsell(widget);
   pendingWidgets.clear();
  });
 };
 discover(document);
 for (const widget of pendingWidgets) enhanceUpsell(widget);
 pendingWidgets.clear();
 new MutationObserver(records => {
  for (const record of records) {
   const widget = record.target instanceof Element && record.target.closest('lb-upsell-widget');
   if (widget) pendingWidgets.add(widget);
   else for (const node of record.addedNodes) if (node instanceof Element) discoveryRoots.add(node);
  }
  if (pendingWidgets.size || discoveryRoots.size || [...imageObservers.keys()].some(widget => !widget.isConnected)) queue();
 }).observe(document.body, {childList:true,subtree:true});
}

  } catch(e) { console.error(e); }
})();
})();
